import { useURL } from '@kalyzee/kast-web-sdk/web-components';
import { AppNavigate } from './AppNavigate';
import { getGlobalQuery, NavigateGlobalQuery } from './queries';

interface LoginRedirectionRouteProps {
  defaultTo: string;
}

const LoginRedirect = ({ defaultTo }: LoginRedirectionRouteProps) => {
  const url = useURL();
  // The query read applies the single decode matching the single encode done
  // by whoever set `redirect` (PublicRedirect / getPageUrl).
  const redirection = getGlobalQuery(url.href, NavigateGlobalQuery.REDIRECT) ?? '';
  return <AppNavigate to={redirection ? `/${redirection}` : defaultTo} replace />;
};

export default LoginRedirect;
